import axios from 'axios';

//const BASE_URL = process.env.NODE_ENV == 'production' ? '' : 'http://127.0.0.1:1323';
export const BASE_URL = process.env.NODE_ENV == 'production' ? '' : 'http://x1:1323';

export default axios.create({
  baseURL: BASE_URL,
  headers: {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${localStorage.token}`
  }
})




// WEBPACK FOOTER //
// ./src/endpoint.js